<!-- dialog.component.html -->
<c-modal [visible]="visible" (visibleChange)="onModalVisibleChange($event)">
  <c-modal-header>
    <h5 cModalTitle>{{ data?.title }}</h5>
    <button (click)="close()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    {{ data?.message }}
  </c-modal-body>
  <c-modal-footer>
    <!-- One button. This dialog only ever announces something the user can
         acknowledge, so a second button beside it dismissed identically and
         made the reader look for a difference that was never there. -->
    <button cButton color="primary" (click)="close()">
      {{ data?.okText || 'Close' }}
    </button>
  </c-modal-footer>
</c-modal>
